import Vue from 'vue';

export const secondVue = new Vue();
